module.exports = __webpack_public_path__ + "img/tipocontacto01.07e2f63.svg";